/*
 * File: Insurance.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Fetches and styles the list of patient insurances
 */
import React, { useEffect, useState } from "react";
import PatientChart from "services/patients/topofthechart/PatientChart";
import { withStyles } from "@material-ui/core/styles";
import Api from "../InsuranceAndGuarantorsAPI";
import PatientIdStorage from "../../store/PatientIdStore";
import UINotFound from "components/ui/UINotFound";
import PropTypes from "prop-types";
import InsuranceRecord from "./InsuranceRecord";
import { List, Toolbar } from "@material-ui/core";
import UIProgress from "components/ui/UIProgress";
import FabSpacer from "components/ui/FabSpacer";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-3),
    marginTop: theme.spacing(2.5)
  }
});

const Insurance = ({ match, classes }) => {
  const [patientInsurance, setPatientInsurance] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const patientId = Number(
        match.params.patientId || PatientIdStorage.getId()
      );
      const patientInsuranceList = await Api.getInsurance(patientId);
      setPatientInsurance(patientInsuranceList);
      setLoading(false);
    };
    fetchData();
  }, [match.params.patientId]);

  if (loading) return <UIProgress />;
  else if (patientInsurance.length === 0) {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle="Insurance"
            pageSubtitle="Insurance & Guarantors"
          />
        </Toolbar>
        <UINotFound message="This Patient Has No Insurance" />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <PatientChart />
        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle="Insurance"
            pageSubtitle="Insurance & Guarantors"
          />
        </Toolbar>
        <List>
          {patientInsurance.map((insurance, index) => {
            return <InsuranceRecord insurance={insurance} key={index} />;
          })}
          <FabSpacer />
        </List>
      </React.Fragment>
    );
  }
};

Insurance.propTypes = {
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Insurance);
